import { FileType } from '@assembly-web/services';

import audio from './fileIcons/audio.svg';
import document from './fileIcons/document.svg';
import genericFile from './fileIcons/genericFile.svg';
import image from './fileIcons/image.svg';
import pdf from './fileIcons/pdf.svg';
import presentation from './fileIcons/presentation.svg';
import spreadsheet from './fileIcons/spreadsheet.svg';
import video from './fileIcons/video.svg';
import zip from './fileIcons/zip.svg';

export const fileIcons: Record<FileType, string> = {
  [FileType.Document]: document,
  [FileType.GenericFile]: genericFile,
  [FileType.Image]: image,
  [FileType.Pdf]: pdf,
  [FileType.Presentation]: presentation,
  [FileType.Spreadsheet]: spreadsheet,
  [FileType.Video]: video,
  [FileType.Zip]: zip,
  [FileType.Audio]: audio,
};
